<!--
  Action dialog "Betrag überschreiben" (04-frontend.md §7).

  IMPORTANT: This file contains NO form HTML. New amount and reason are rendered by the transient
  form widget built from the MvsFormDto in the TS — repo precedent wf-process-start.component.html,
  identical to the sibling dialogs. Only the dialog frame, the amount comparison, the threshold
  warning and the action buttons live here.
-->
<p-dialog
        header="Betrag überschreiben"
        [visible]="visible"
        (visibleChange)="handleVisibleChange($event)"
        (onShow)="handleShow()"
        [modal]="true"
        [draggable]="false"
        [resizable]="false"
        [style]="{width: '44rem'}"
        [breakpoints]="{'960px': '90vw'}"
        styleClass="cp-provision-agent-amount-overwrite-dialog">

    @if (busy && !formWidget) {

        <p-skeleton height="14rem"></p-skeleton>

    } @else if (formWidget) {

        <!-- Context: which Provisionssatz -->
        <div class="flex flex-wrap align-items-center gap-2 mb-3">
            <span class="text-color-secondary text-sm">Provisionssatz</span>
            <span class="font-medium">{{ provisionContractAgentLabel ?? ('#' + provisionContractAgentId) }}</span>
        </div>

        <!-- The dialog opens with the action available (optimistic, see the class TSDoc); this
             banner appears only after the SERVER refused with a 403. -->
        @if (!canAgentChange) {
            <p-message severity="warn" styleClass="w-full mb-3">
                <span>
                    Der Server hat das Überschreiben verweigert: Ihnen fehlt das Recht
                    <strong>cp_agentChange</strong>. Die Werte können angesehen, aber nicht
                    geschrieben werden.
                </span>
            </p-message>
        }

        <!-- The calculated amount stays visible next to the new one (BR-065) -->
        <div class="surface-100 border-round p-3 mb-3">
            <div class="flex flex-wrap gap-4">

                <div class="flex flex-column">
                    <span class="text-color-secondary text-sm">Gerechneter Betrag</span>
                    <span class="font-semibold">
                        {{ calculatedAmount !== null ? (calculatedAmount | currency:'EUR') : '–' }}
                    </span>
                </div>

                <div class="flex flex-column">
                    <span class="text-color-secondary text-sm">Aktuelles Soll</span>
                    <span class="font-semibold">
                        {{ currentAmount !== null ? (currentAmount | currency:'EUR') : '–' }}
                    </span>
                </div>

                <div class="flex flex-column">
                    <span class="text-color-secondary text-sm">Netto-Differenz</span>
                    <span class="font-semibold">
                        {{ netDifference !== null ? (netDifference | currency:'EUR') : '–' }}
                    </span>
                </div>

            </div>
        </div>

        <!-- Capture: metadata-driven form widget -->
        <mvs-widget
                [widgetData]="formWidget"
                (onGenericEvent)="handleGenericEvent($event)">
        </mvs-widget>

        <!-- Threshold warning (AX-09) — a warning, not a lock -->
        @if (exceedsThreshold) {
            <p-message severity="warn" styleClass="w-full mt-3">
                <span>
                    <i class="fa-regular fa-triangle-exclamation mr-2"></i>
                    Die Abweichung übersteigt den Schwellenwert von
                    <strong>{{ overwriteThreshold | currency:'EUR' }}</strong> dieses Provisionstyps.
                    Der nächste Lauf hält das als Lauf-Meldung fest.
                </span>
            </p-message>
        }

        @if (failureMessage) {
            <p-message severity="error" [text]="failureMessage" styleClass="w-full mt-3"></p-message>
        }

    }

    <ng-template pTemplate="footer">
        <p-button
                label="Abbrechen"
                icon="fa-regular fa-xmark"
                severity="secondary"
                [text]="true"
                (onClick)="handleClose()">
        </p-button>

        <p-button
                label="Betrag überschreiben"
                icon="fa-regular fa-check"
                severity="primary"
                [loading]="busy"
                [disabled]="!submittable"
                [pTooltip]="submitTooltip"
                tooltipPosition="top"
                (onClick)="handleOverwriteAmount()">
        </p-button>
    </ng-template>

</p-dialog>
